<template>
  <div>
    <Header />
    <div class="privacy">
      <div class="privacy-top breadcrumbs d-flex align-items-center">
        <div
          class="container position-relative d-flex flex-column align-items-center"
        >
          <h2>{{ $t("privacy_policy.privacy_policy") }}</h2>
        </div>
      </div>
      <!-- <img src="../../../assets/images/info/privacy-us.jpg" alt="" /> -->
    </div>
    <b-container>
      <b-row class="privacy-block1-img">
        <b-col sm="12" md="12" class="privacy-block1-col">
          <div class="privacy-block1-info container">
            <p class="lead">{{ $t("privacy_policy.privacy_main") }}</p>
            <ol class="ml-2">
              <li>
                <strong> {{ $t("privacy_policy.privacy_label1") }}: </strong>
                {{ $t("privacy_policy.privacy_p1") }}
                <div class="inner_list">
                  <ul class="mt-1">
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p1_1") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p1_2") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p1_3") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p1_4") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p1_5") }}
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <strong> {{ $t("privacy_policy.privacy_label2") }}: </strong>
                {{ $t("privacy_policy.privacy_p2") }}
                <div class="inner_list">
                  <ul class="mt-1">
                    <li>
                      <i class="fa-solid fa-circle-check" />{{
                        $t("privacy_policy.privacy_p2_1")
                      }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p2_2") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p2_3") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p2_4") }}
                    </li>
                    <li>
                      <i class="fa-solid fa-circle-check" />
                      {{ $t("privacy_policy.privacy_p2_5") }}
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <strong> {{ $t("privacy_policy.privacy_label3") }}: </strong>
                {{ $t("privacy_policy.privacy_p3") }}
              </li>
              <li>
                <strong> {{ $t("privacy_policy.privacy_label4") }}: </strong>
                {{ $t("privacy_policy.privacy_p4") }}
              </li>
              <li>
                <strong> {{ $t("privacy_policy.privacy_label5") }}: </strong>
                {{ $t("privacy_policy.privacy_p5") }}
              </li>
              <li>
                <strong> {{ $t("privacy_policy.privacy_label6") }}: </strong>
                {{ $t("privacy_policy.privacy_p6") }}
              </li>
              <li>
                <strong> {{ $t("privacy_policy.privacy_label7") }}: </strong>
                {{ $t("privacy_policy.privacy_p7") }}
              </li>
            </ol>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from "@/layouts/landpage/HeaderHome.vue";
import Footer from "@/layouts/landpage/Footer.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { BFormInput } from "bootstrap-vue";
import { required, email } from "@validations";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      name: "",
      email: "",
      message: "",
    };
  },
};
</script>

<style scoped>
.privacy {
  /* margin-top: 110px; */
  margin-bottom: 75px;

  /* padding: 40px 40px 128px 40px; */
}
.privacy-block1-col {
  margin: auto;
  padding-bottom: 50px;
}

.privacy .contact-top {
  height: 290px;
}
.privacy .privacy-block1-img img {
  height: 300px;
}
.privacy .privacy-block1-info {
  margin-top: 50px;
}
.privacy .privacy-block1-info h2 {
  font-size: 25px;
  color: #005692;
}
.privacy .privacy-block1-info p {
  font-size: 16px;
  font-weight: 500;
  text-align: justify;
}

@media (max-width: 550px) {
  .privacy .privacy-top img {
    width: 330px;
  }
  .privacy .privacy-block1-img img {
    display: none;
  }
  .privacy .privacy-block1-info p {
    text-align: start;
  }
}

.privacy-block2 {
  margin-top: 60px;
}
.privacy-block2 h2 {
  text-align: center;
  font-weight: 500;
  color: #005692;
  margin-bottom: 45px;
}

[dir] .card-img,
[dir] .card-img-top {
  height: 250px;
}
[dir] .card .card-title {
  color: #366ce3;
  font-weight: 500;
  cursor: pointer;
}
[dir] .card-text:last-child {
  font-size: 14px;
}
@media (max-width: 550px) {
  .block-cvshot .card {
    position: relative;
    display: flex;
    min-width: 0;
    word-wrap: break-word;
    align-content: flex-start;
    flex-direction: column-reverse;
    flex-wrap: wrap;
  }
  .block-cvshot img {
    margin: 0 7px;
    width: 350px;
  }
}
@media (min-width: 920px) {
  .block-cvshot .card .card-title {
    color: #366ce3;
    font-weight: 600;
    font-size: 22px;
  }
  .block-cvshot .card-text:last-child {
    font-size: 15px;
  }
}
@media (min-width: 920px) {
  [dir="ltr"] .card-body {
    padding: 1.5rem;
    min-height: 350px;
  }
  .cvshots-card .card-body {
    min-height: auto;
    margin: auto;
  }
}
.card-text:last-child {
  font-size: 16px;
  font-weight: 500;
}

.privacy-top {
  background-image: url(../../../assets/images/info/about-header.jpg);
  padding: 140px 0 60px 0;
  min-height: 30vh;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.breadcrumbs:before {
  content: "";
  background-color: rgba(27, 47, 69, 0.7);
  position: absolute;
  inset: 0;
}
.breadcrumbs h2 {
  font-size: 56px;
  font-weight: 500;
  color: #fff;
  font-family: var(--font-secondary);
}

.inner_list ul {
  list-style: none;
  padding: 0;
}
.privacy-block1-info ol {
  padding: 0;
}

.privacy-block1-info ol li,
.inner_list ul li {
  padding: 0 0 15px 26px;
  position: relative;
  font-size: 15px;
}
.privacy-block1-info ol li i,
.inner_list ul li i {
  font-size: 16px;
  color: #56b8e6;
}
.blockchainImg {
  width: 450px;
}
@media (max-width: 550px) {
  .blockchainImg {
    display: none;
    /* width: 400px; */
  }
  .privacy-block2 h2 {
    font-size: 18px;
  }
}
</style>
<style scoped>
@media (min-width: 920px) {
  [dir="rtl"] .card-body {
    padding: 1.5rem;
    min-height: 250px;
  }
}
</style>
